/* ============================================================
   FSR – Cart Gift: Geschenk(e) ab Schwelle automatisch
   hinzufügen / entfernen (Geschenkstufen Cart Drawer)
   Konfiguration kommt aus data-Attributen der
   fsr-cart-progress-bar (Theme-Editor-Settings).

   09-10 erweitert (Anni/Claude): unterstützt jetzt bis zu 2
   unabhängige Geschenkstufen (Stufe 2 additiv, bricht nichts
   an Stufe 1, wenn Stufe 2 nicht konfiguriert ist).
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-fsr-cart-progress]';
  var CART_ROUTES = /\/cart\/(add|change|update|clear)/;
  var busy = false;
  var pendingHints = [];

  /* Oktoberaktion 2026 (Uta, 30.09.): Geschenke im Aktionszeitraum pausiert.
     In dieser Zeit kein Geschenk hinzufügen und vorhandene Geschenk-Zeilen
     entfernen (Absicherung, falls eine zwischengespeicherte Seite noch die
     Geschenk-Daten enthält). Nach der Aktion (09.10.) wieder entfernen. */
  var PAUSE_START = Date.parse('2026-10-01T22:00:00Z');
  var PAUSE_END = Date.parse('2026-10-12T22:00:00Z');
  function isPaused() {
    var now = Date.now();
    return now >= PAUSE_START && now < PAUSE_END;
  }
  function removeGiftsWhilePaused() {
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (cart) { return cart.json(); })
      .then(function (cart) {
        var giftLines = cart.items.filter(function (item) {
          return item.properties && item.properties._fsr_gift;
        });
        if (!giftLines.length) return;
        return Promise.all(giftLines.map(function (line) {
          return mutate('/cart/change.js', { id: line.key, quantity: 0 });
        })).then(refreshDrawer);
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function getConfigs() {
    var el = document.querySelector(SELECTOR);
    if (!el) return [];
    var configs = [];

    var variant1 = parseInt(el.getAttribute('data-fsr-gift-variant'), 10);
    var threshold1 = parseInt(el.getAttribute('data-fsr-gift-threshold'), 10);
    if (variant1 && threshold1) {
      configs.push({
        key: 'gift1',
        variant: variant1,
        threshold: threshold1,
        removedText: el.getAttribute('data-fsr-gift-removed-text') || '',
        hintSelector: '[data-fsr-gift-hint]'
      });
    }

    var variant2 = parseInt(el.getAttribute('data-fsr-gift-variant-2'), 10);
    var threshold2 = parseInt(el.getAttribute('data-fsr-gift-threshold-2'), 10);
    if (variant2 && threshold2) {
      configs.push({
        key: 'gift2',
        variant: variant2,
        threshold: threshold2,
        removedText: el.getAttribute('data-fsr-gift-removed-text-2') || '',
        hintSelector: '[data-fsr-gift-hint-2]'
      });
    }

    return configs;
  }

  function money(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function mutate(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function showHints(attempt) {
    if (!pendingHints.length) return;
    var remaining = [];
    pendingHints.forEach(function (h) {
      var hint = document.querySelector(h.selector);
      if (hint) {
        hint.textContent = h.text;
        hint.hidden = false;
      } else {
        remaining.push(h);
      }
    });
    pendingHints = remaining;
    if (pendingHints.length && (attempt || 0) < 10) {
      setTimeout(function () { showHints((attempt || 0) + 1); }, 300);
    }
  }

  function checkCart() {
    if (isPaused()) { if (!busy) removeGiftsWhilePaused(); return; }
    var configs = getConfigs();
    if (!configs.length || busy) return;
    busy = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (cart) { return cart.json(); })
      .then(function (cart) {
        var giftVariantIds = configs.map(function (c) { return c.variant; });
        var total = 0;
        var giftLinesByVariant = {};

        cart.items.forEach(function (item) {
          var giftIdx = giftVariantIds.indexOf(item.variant_id);
          var isGift = giftIdx !== -1 || (item.properties && item.properties._fsr_gift);
          if (isGift) {
            if (!giftLinesByVariant[item.variant_id]) giftLinesByVariant[item.variant_id] = item;
            return;
          }
          if (item.requires_shipping) total += item.final_line_price;
        });

        (cart.cart_level_discount_applications || []).forEach(function (d) {
          total -= d.total_allocated_amount || 0;
        });

        var actions = [];
        pendingHints = [];

        /* Stufen ERSETZEN sich gegenseitig, sie stapeln sich nicht: nur die
           höchste erreichte Stufe bekommt ihr Geschenk im Warenkorb.
           configs ist aufsteigend nach Schwelle sortiert (gift1, gift2). */
        var activeCfg = null;
        configs.forEach(function (cfg) {
          if (total >= cfg.threshold) activeCfg = cfg;
        });

        configs.forEach(function (cfg) {
          var giftLine = giftLinesByVariant[cfg.variant];
          var shouldHave = activeCfg && activeCfg.variant === cfg.variant;

          if (shouldHave) {
            if (!giftLine) {
              actions.push(mutate('/cart/add.js', {
                items: [{ id: cfg.variant, quantity: 1, properties: { _fsr_gift: '1' } }]
              }));
            } else if (giftLine.quantity > 1) {
              /* Mengen-Guard: Geschenk immer genau 1x */
              actions.push(mutate('/cart/change.js', { id: giftLine.key, quantity: 1 }));
            }
          } else if (giftLine) {
            /* Nur einen "Geschenk entfernt"-Hinweis zeigen, wenn der Kunde
               tatsächlich unter DIESE Schwelle gefallen ist – nicht, wenn das
               Geschenk nur durch eine höhere Stufe ersetzt wurde. */
            if (total < cfg.threshold) {
              pendingHints.push({
                selector: cfg.hintSelector,
                text: cfg.removedText.replace('[betrag]', money(cfg.threshold - total))
              });
            }
            actions.push(mutate('/cart/change.js', { id: giftLine.key, quantity: 0 }));
          }
        });

        if (actions.length) {
          return Promise.all(actions).then(function () {
            refreshDrawer();
            showHints(0);
          });
        }
      })
      .catch(function () { /* stumm scheitern – Serverstand bleibt korrekt */ })
      .finally(function () { busy = false; });
  }

  /* Fetch-Interception: reagiert auf jede Cart-Mutation des Themes */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var promise = origFetch.apply(this, arguments);
    if (CART_ROUTES.test(url) && !busy) {
      promise.then(function () { setTimeout(checkCart, 50); }).catch(function () {});
    }
    return promise;
  };

  document.addEventListener('DOMContentLoaded', checkCart);
})();
